<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 30 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
        操作
        </div>
      </div>
      <div solt="title" style="position: relative">
      </div>
      <div class="content" id="duihuanid">
        <div class="content_div">
          <!-- 1 -->
          <div style="display: flex;margin-top: 1.5rem;">
            <div class="content_div_name">
              <div style="flex-shrink: 0;">交易類型：</div>
              <a-select v-model="form.transaction_type"  style="width: 100%;" @change='jyClcik()'>
                <a-select-option value="1">買入</a-select-option>
                <a-select-option value="2">賣出</a-select-option>
              </a-select>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
              <div style="flex-shrink: 0;">產品編號：</div>
              <a-input v-model="form.product_code" disabled  placeholder="請輸入產品編號"/>
            </div>
          </div>
          <!-- 1 -->
          <div style="display: flex;margin-top: 1.5rem;">
            <div class="content_div_name">
              <div style="flex-shrink: 0;">產品名稱：</div>
               <a-input v-model="form.product_name" disabled  placeholder="請輸入產品名稱"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name" v-if="typeFlag">
              <div style="flex-shrink: 0;">買入數量：</div>
              <a-input-number style="width: 100%;" class="hide_arrows"  :class="arrList.obj1 ? 'border_cla':''" @change="arrList.obj1 = false" v-model="form.transaction_unit"  placeholder="請輸入買入數量"/>
            </div>
            <div class="content_div_name" v-else>
              <div style="flex-shrink: 0;">賣出數量：</div>
              <a-input-number style="width: 100%;" class="hide_arrows"  :class="arrList.obj1 ? 'border_cla':''" @change="arrList.obj1 = false" v-model="form.transaction_unit"  placeholder="請輸入賣出數量"/>
            </div>
          </div>
          <!-- 2  -->
          <div style="display: flex;margin-top: 1.5rem;">
            <div class="content_div_name" v-if="typeFlag">
              <div style="flex-shrink: 0;">買入價格：</div>
              <a-input-number style="width: 100%;" class="hide_arrows" :class="arrList.obj2 ? 'border_cla':''" @change="arrList.obj2 = false" v-model="form.transaction_price"  placeholder="請輸入買入價格"/>
            </div>
            <div class="content_div_name" v-else>
              <div style="flex-shrink: 0;">賣出價格：</div>
              <a-input-number style="width: 100%;" class="hide_arrows" :class="arrList.obj2 ? 'border_cla':''" @change="arrList.obj2 = false" v-model="form.transaction_price"  placeholder="請輸入賣出價格"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name" v-if="typeFlag">
              <div style="flex-shrink: 0;">買入金額：</div>
              <a-input-number style="width: 100%;" class="hide_arrows" :class="arrList.obj3 ? 'border_cla':''" @change="arrList.obj3 = false" v-model="form.transaction_amount"  placeholder="請輸入買入金額"/>
            </div>
            <div class="content_div_name" v-else>
              <div style="flex-shrink: 0;">賣出金額：</div>
              <a-input-number style="width: 100%;" class="hide_arrows" :class="arrList.obj3 ? 'border_cla':''" @change="arrList.obj3 = false" v-model="form.transaction_amount"  placeholder="請輸入賣出金額"/>
            </div>
          </div>
          <!-- 3-1 -->
          <div style="display: flex;margin-top: 1.5rem;" >
            <div class="content_div_name">
              <div style="flex-shrink: 0;">提交日期：</div>
              <!-- :class="arrList.obj9 ? 'border_cla':''" -->
              <a-date-picker v-model="form.submit_date" :disabled-date="disabledDate" placeholder='請選擇提交日期' style="width: 100%;"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
            </div>
          </div>
        </div>
        <div class="content_btn">
          <div class="content_btn_div" @click="subClick()">提&emsp;交</div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>

    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import moment, { max } from 'moment';
export default {
  props: ["items","investmentAmount"],
  data() {
    return {
      typeFlag:true,
      arrList:{
        obj1:false,
        obj2:false,
        obj3:false,
      },
      ishand: false,
      visible: true,
      timeFlag: false,
      form:{
        transaction_type:'1',    
        product_code:'',
        product_name:'',
        transaction_unit:'',
        transaction_price:'',
        transaction_amount:'',
        submit_date:''
      }
     
    };
  },
  mounted() {
    console.log(this.items);
    
    this.form.product_code = this.items.product_code
    this.form.product_name = this.items.product_name
    this.form.submit_date =  new Date().toLocaleDateString()
  },
  methods: {
    dateFlag(){
      this.timeFlag = true
    },
     getCurrentData(){
      return new Date().toLocaleDateString();
    },
    disabledDate(current){
      // 不可以选择之前的日期,今天包括之后可以选，控制大于小于来实现选择之前的日期还是之后的日期
      return current > moment().subtract(0, 'day');
    },


    handleCancel(ev) {
        this.$emit("child", 0);
    },
    jyClcik(val){
      this.typeFlag = !this.typeFlag
      this.form.transaction_unit = ''
      this.form.transaction_price = ''
      this.form.transaction_amount = ''
      this.form.submit_date = this.getCurrentData()
       
    },
    subClick(){
      if (!this.form.transaction_unit) {
        this.arrList.obj1 = true
        return
      }
      if (!this.form.transaction_price) {
        this.arrList.obj2 = true
        return
      }
      if (!this.form.transaction_amount) {
        this.arrList.obj3 = true
        return
      }
      this.form.account_number = this.items.account_number
      this.form.id = this.items.id
      this.$ajax({
        method: 'post',
        url: this.$api.buyOrSellInvestmentProductById,
        data: this.form
      }).then(res => {
        if (res.data.qmiscode === 1000) {
          this.$message.success(res.data.qmismsg);
          this.$emit("child", 0);
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      })
    },

  },
};
</script>

<style lang="scss">
  .border_cla {
    border-color: red !important;
  }
  .border_cla .ant-input{
    border-color: red !important;
  }
  .border_cla1{
    border: 1px solid red;
    border-radius: 4px;
  }
	@media screen and (min-width:2200px){
    .content{
      font-size: 20px !important;
    }
    .saveBtn {
      font-size: 20px !important;
    }
    .content_btn_div{
      font-size: 20px !important;
    }
    .ant-select-selection__rendered {
      height: 100%;
      font-size: 0.8rem !important;
    }
    .convert_cla{
      font-size: 18px !important;
    }

  }
  .convert_cla{
      font-size: 14px;
    }
.ant-select-dropdown-menu {
    max-height: 500px !important; 
  }
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 2.5rem 1rem 1.5rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
  font-size: 16px;
}
.content_div_name{
  display: flex;
  align-items: center;
  width: 100%;
}
.content_btn{
  margin-top: 1.5rem;
}
.content_btn_div{
  width: 25%;
  background: #0c8b97;
  padding: 10px 0;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  margin: auto;
  cursor: pointer;

}
</style>
